import React from 'react'
import './_numeric-keypad.scss'
interface IKeypadProps {
  onKeyPress: (key: string) => void
  onBackspace: () => void
}

const CustomNumericKeypad: React.FC<IKeypadProps> = ({ onKeyPress, onBackspace }) => {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'backspace']

  return (
    <div className="kiosk-keypad">
      {keys.map((key) =>
        key === 'backspace' ? (
          <button key={key} onClick={onBackspace} className="kiosk-key">
            &#9003; {/* Backspace Icon */}
          </button>
        ) : key === '' ? (
          <div key="empty"></div>
        ) : (
          <button key={key} onClick={() => onKeyPress(key)} className="kiosk-key">
            {key}
          </button>
        )
      )}
    </div>
  )
}

export default CustomNumericKeypad
